(() => {
  'use strict';
  const root=document.querySelector('[data-dg-lab-tool="color-banding"]');
  if(!root) return;
  if(root.dataset['dgLabColorBandingInitialized'] === 'true') return;
  root.dataset['dgLabColorBandingInitialized'] = 'true';
  const stage=root.querySelector('#stage');
  const level=root.querySelector('#level');
  if(stage) stage.style.background='linear-gradient(90deg,#000,#f00,#ff0,#0f0,#0ff,#00f,#f0f,#fff)';

  function setStatus(text){ const status=root.querySelector('.status'); if(status) status.textContent=text; }
  async function toggleFullscreen(target){
    if(!target || !document.fullscreenEnabled){ setStatus('No disponible'); return; }
    try{
      if(document.fullscreenElement) await document.exitFullscreen();
      else await target.requestFullscreen();
    }catch(error){ setStatus('No disponible'); }
  }

  root.querySelector('#full').addEventListener('click',()=>toggleFullscreen(stage));
  root.querySelector('#brightness').addEventListener('input',event=>{ if(stage) stage.style.filter=`brightness(${event.target.value}%)`; if(level) level.textContent=event.target.value; });
  document.addEventListener('fullscreenchange',()=>{ const state=root.querySelector('#state'); if(state) state.textContent=document.fullscreenElement?'Pantalla completa activa · Pulsa Esc para salir':'Listo'; });
})();
